import config from '../../config';

export default {
  url: `${config.api.baseURL}/modules/:moduleSlug/pages`,
  transformer(data) {
    return data;
  }
};
